import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { DocumentCategoryDto } from './documentCategory.dto';

export class DocumentDto extends BaseDto {
  name?: string;
  description?: string;
  documentUrl?: string;
  documentCategoryId: number;
  documentCategory: DocumentCategoryDto;
  merchants: MerchantDto[];
}
